export default __webpack_public_path__ + "static/media/background0.9fd36d27.png";